import React from "react";
import { HERO_BENEFITS, highlightBenefitText } from "./heroBenefits.js";

const HeroBenefitList = () => (
  <ul className="cursor-value-list" aria-label="FractoLabs benefits">
    {HERO_BENEFITS.map((benefit, index) => (
      <li
        key={benefit.id}
        className="cursor-value-item"
        style={{ animationDelay: `${index * 120}ms` }}
      >
        <span className="cursor-value-prefix" aria-hidden="true">
          &gt;
        </span>
        <span>{highlightBenefitText(benefit.text, benefit.highlights)}</span>
      </li>
    ))}
  </ul>
);

export default HeroBenefitList;
